// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  font-size: 16px !important;
}

ion-toolbar {
  padding-inline: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal-header/modal-header.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;AACJ;;AACA;EACI,4BAAA;AAEJ","sourcesContent":["ion-title {\n    font-size: 16px !important;\n}\nion-toolbar {\n    padding-inline:0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
